import React from 'react';
// Static gradient background — no animations, no blur filters
// Visually identical at these low opacities but eliminates constant GPU repaints
export function AuroraBackground() {
  return <div className="fixed inset-0 -z-10" style={{
    background: `
        linear-gradient(to bottom, #FBF8F3, #F5F1E8 60%, #F9F5EF),
        radial-gradient(ellipse at 15% 10%, rgba(212, 165, 116, 0.18) 0%, transparent 55%),
        radial-gradient(ellipse at 85% 20%, rgba(232, 184, 109, 0.12) 0%, transparent 50%),
        radial-gradient(ellipse at 50% 80%, rgba(200, 180, 150, 0.14) 0%, transparent 55%)
      `
  }} data-id="element-3" />;
}